import actions from "./actions";

const initState = {
  surveys: [],
  survey: null,
  key: null,
  assertionID: "",
  loading: false,
  error: "",
  report: [],
  schools: [],
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_ALL_SURVEYS_SUCCESS:
      return {
        ...state,
        surveys: action.surveys,
        assertionID: "",
      };

    case actions.UPLOAD_SURVEY_DETAILS:
    case actions.EDIT_SURVEY_DETAILS:
      return {
        ...state,
        assertionID: "",
      };

    case actions.UPLOAD_SURVEY_DETAILS_SUCCESS:
      return {
        ...state,
        assertionID: action.assertionID,
      };

    case actions.SET_SURVEY_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    case actions.SET_SURVEY_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case actions.SET_FILTER:
      return {
        ...state,
        key: action.key,
      };

    case actions.RESET:
      return {
        ...state,
        surveys: [],
        subjects: [], // Note: subjects and grades aren't in initial state — do you want to remove these?
        grades: [],
        survey: null,
        assertionID: "",
      };

    case actions.SET_SURVEY_REPORT:
      return {
        ...state,
        report: action.payload.data,
      };

    case actions.GET_ALL_SCHOOLS_SURVEY_SUCCESS:
      return {
        ...state,
        schools: action.schools,
      };

    default:
      return state;
  }
}
